
export default (value) => {
  switch (value) {
    case 'anonymous': return 'Marked as anonymous'
    case 'verified': return 'Verified'
    case 'reviewDescription': return 'Review Text'
    case 'userExperienceTags': return 'User Experience Tags'
    case 'reasonForChoosingLender': return 'Reason for Choosing Lender'

    case 'scoreWeighted': return 'Weighted Review Score'
    case 'scoreAverage': return 'Average Customer Review Score'
    case 'scoreOverall': return 'Overall Score'
    case 'scoreClarity': return 'Clarity of Information'
    case 'scoreGathering': return 'Data Gathering Process'
    case 'scoreTimeliness': return 'Timeliness'
    case 'scoreResponsiveness': return 'Responsiveness'

    case 'dealType': return 'Deal Type'
    case 'practiceType': return 'Practice Type'
    case 'dealSize': return 'Deal Size'
    case 'creditScore': return 'Credit Score'
    case 'loanPaymentTerms': return 'Loan Payment Terms'
    case 'loanType': return 'Loan Type'
    case 'speedOfClosing': return 'Speed Of Closing'
    case 'lenderFeatures': return 'Lender Features'
    case 'hasRegulatoryIssues': return 'Has Regulatory Issues'
    case 'hasDisclosureEvents': return 'Has Disclosure Events'
    case 'createdAt': return 'Matched On'
    default: return ''
  }
}
